import type { IconData } from '@stacksjs/iconify-core'

export const smallArrowLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M185 414q-10 0-16-7L7 245q-7-7-7-16t7-17L169 50q7-7 17-7t16 7t7 16t-7 17L56 229l146 146q7 7 7 16t-7 16t-17 7\"/>",
  "width": 210,
  "height": 700,
  "viewBox": "0 0 210 700"
}

export default smallArrowLeft
